import { render, staticRenderFns } from "./item-dialog.vue?vue&type=template&id=8ed4d53a&scoped=true&"
import script from "./item-dialog.vue?vue&type=script&lang=js&"
export * from "./item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./item-dialog.vue?vue&type=style&index=0&id=8ed4d53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed4d53a",
  null
  
)

export default component.exports